import { PRE_DELIVERY } from "../const/products";
var shouldShowPreDeliveryMessage = function (conditions, featureFlags) {
    return ((conditions === null || conditions === void 0 ? void 0 : conditions.includes(PRE_DELIVERY)) &&
        Boolean(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.isPreDeliveryMessageEnabled));
};
export default shouldShowPreDeliveryMessage;
//# sourceMappingURL=shouldShowPreDeliveryMessage.js.map